import React, { Component } from 'react';
import styled from 'styled-components';
import Notification from './Notification';

const NotificationGroup = styled.div`
  z-index: ${p => p.theme.elevation[2]};
  width: 100%;
`;

class NotificationSlot extends Component {

  render() {
    const { items, closeIconLabel = 'Close' } = this.props;

    const notificationItems = items.map((notification) => {
      return (
        <Notification key={`notification-${notification.id}`} {...notification} closeIconLabel={closeIconLabel} />
      );
    });

    return (
      <NotificationGroup>
        { notificationItems }
      </NotificationGroup>
    );
  }
}

export default NotificationSlot;
